<template>
  <div class="container">
    <!-- 面包屑 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>系统设置</el-breadcrumb-item>
      <el-breadcrumb-item>次卡管理</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="between">
      <div class="left_con">
        <div class="left_inner_con">
          <el-input size="mini"
                    style="margin-bottom: 10px;position:sticky;z-index: 99;top:0;"
                    placeholder="输入关键字进行过滤"
                    v-model="filterText">
          </el-input>
          <el-tree
            :data="orgList"
            :props="treeProps"
            :highlight-current="true"
            node-key="id"
            show-checkbox
            :filter-node-method="filterNode"
            ref="tree">
          </el-tree>
        </div>
      </div>
      <div class="table_container" style="border: 0 solid rgb(222,222,222);margin: 10px 0">
        <el-button size="mini"  plain @click="showCkDialog(1)" >创建次卡</el-button>
        <el-button size="mini"  plain @click="sjCk" >上架次卡</el-button>
        <el-button size="mini"  plain @click="xjCk" >下架次卡</el-button>
        <el-table height="600px" :data="ckList" fit border stripe="stripe"
                  :header-cell-style="{background:'#eff3f8', color:'#333'}"
                  :row-style="{height: '0'}"
                  @selection-change="handleSelectionChange"
        >
          <el-table-column
            type="selection"
            :selectable="checkSelect"
            width="55">
          </el-table-column>
          <el-table-column
            align="center"
            prop="cardTypeName"
            label="次卡名称" width="200">
          </el-table-column>
          <el-table-column
            align="center"
            prop="state"
            :formatter="typeFormatter"
            label="状态" width="100">
          </el-table-column>
          <el-table-column
            align="center"
            prop="cardNum"
            label="次数" width="100">
          </el-table-column>
          <el-table-column
            align="center"
            prop="price"
            label="标准价格" width="100">
          </el-table-column>
          <el-table-column
            align="center"
            prop="useTypeName"
            label="适用项目" width="100">
          </el-table-column>
          <el-table-column
            align="center"
            prop="validDate"
            label="有效期" width="100">
          </el-table-column>
          <el-table-column
            align="center"
            prop="createName"
            label="创建人" width="100">
          </el-table-column>
          <el-table-column
            align="center"
            prop="createTime"
            label="创建时间" width="100">
          </el-table-column>
          <el-table-column
            align="center"
            prop="modifyName"
            label="最后操作人" width="100">
          </el-table-column>
          <el-table-column
            align="center"
            prop="modifyTime"
            label="最后操作时间" width="100">
          </el-table-column>
        </el-table>
        <div style="margin-top: 3px;">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage1"
            :page-sizes="[10, 20, 30, 50]"
            :page-size="pageSize1"
            layout="total, sizes, prev, pager, next, jumper"
            :total="pageTotal">
          </el-pagination>
        </div>
      </div>
    </div>

    <!--  -->
    <el-dialog
      title="次卡"
      :visible.sync="ckDialogVisible"
      width="60%"
      style="position: absolute"
      @close="closeCkDialog"
      :close-on-click-modal="false"
    >
      <div style="background-color:#eff3f8;width:100%;height: 50px;position: absolute;top: 0;left: 0;z-index:0"></div>
      <div style="text-align: right;">
        <el-button size="mini" plain @click="showConsumptionDialog">选择次卡明细</el-button>
      </div>
      <el-card >
        <div style="display: flex;justify-items: center; justify-content: space-around; width: 100%">
          <div style="width: 50%">
            <span style="width: 20%">名称：</span>
            <el-input v-model="ckInfo.cardTypeName" readonly size="mini"  style="width: 80%;"></el-input>
          </div>
          <div style="width: 50%">
            <span style="width: 20%">标准价格：</span>
            <el-input v-model="ckInfo.price" size="mini" readonly  style="width: 80%;"></el-input>
          </div>
        </div>
        <div style="display: flex;justify-items: center; justify-content: space-around; width: 100%;
            margin-top: 20px;">
          <div style="width: 50%">
            <span style="width: 20%">次数：</span>
            <el-input v-model="ckInfo.cardNum" size="mini" readonly  style="width: 80%;"></el-input>
          </div>
          <div style="width: 50%">
            <span style="width: 20%">适用项目：</span>
            <el-select size="mini" v-model="useType"  placeholder="请选择">
              <el-option
                v-for="item in useTypeList"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </div>
        </div>
        <div style="display: flex;justify-items: center; width: 100%; margin-top: 20px;">
          <div style="width: 50%">
            <span style="width: 20%">截止有效期：</span>
            <el-date-picker
              v-model="ckInfo.validDate"
              type="date"
              placeholder="选择日期"
              value-format="yyyy-MM-dd"
              size="mini">
            </el-date-picker>
          </div>
        </div>
      </el-card>
      <span slot="footer" class="dialog-footer">
            <el-button size="mini" @click="closeCkDialog">取 消</el-button>
            <el-button size="mini" @click="createCk">确 定</el-button>
          </span>
    </el-dialog>

    <!-- 次卡明细 -->
    <el-dialog
      title="次卡明细"
      :visible.sync="ckConsumptionDialogVisible"
      width="60%"
      style="position: absolute"
      @close="closeConsumptionDialog"
      :close-on-click-modal="false"
    >
      <div style="background-color:#eff3f8;width:100%;height: 50px;position: absolute;top: 0;left: 0;z-index:0"></div>
      <el-table :data="ckConsumptionList" fit border stripe="stripe" width="100%"  size="mini"
                :header-cell-style="{background:'#eff3f8', color:'#333'}"
                height="400px">
        <el-table-column
          align="center"
          label="操作"
          width="110">
          <template slot-scope="scope">
            <el-radio :label="scope.$index" v-model="ckInfo.ckIndex"  @change.native="selectCkConsumption(scope.row)">{{''}}</el-radio>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="serviceName"
          label="名称">
        </el-table-column>
        <el-table-column
          align="center"
          prop="price"
          label="标准价格">
        </el-table-column>
        <el-table-column
          align="center"
          prop="cardNum"
          label="次数">
        </el-table-column>
      </el-table>
      <div style="margin-top: 3px;">
        <el-pagination
          @size-change="handleSizeChange1"
          @current-change="handleCurrentChange1"
          :current-page="currentPage1"
          :page-sizes="[10, 20, 30, 50]"
          :page-size="pageSize1"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pageTotal1">
        </el-pagination>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data(){
    return{
      shopId:'',
      userId:'',
      orgList: [],
      filterText: '',
      treeProps: {
        label: 'orgName',
        children: 'children'
      },
      ckList:[],
      selectOrgId:'',
      ckDialogVisible:false,
      ckInfo:{
        cardType: 3,
        cardTypeName:'',
        price:'',
        cardNum:'',
        consumptionId:'',
        useType:'',
        useTypeName:'',
        validDate:'',
        footService:'',
        ckIndex:'',
        creator:''
      },
      useTypeList:[
        {value: 2, label: '修脚'},
        {value: 3, label: '复查'},
        {value: 4, label: '嵌甲处理'},
        {value: 5, label: '足部护理'},
        {value: 6, label: '泡脚'}
      ],
      useType:'',
      ckConsumptionDialogVisible:false,
      ckConsumptionList:[],

      currentPage: 1,
      pageSize:20,
      pageTotal:0,

      currentPage1: 1,
      pageSize1:20,
      pageTotal1:0,
      baseRequest:{
        pageNum:1,
        pageSize:20,
        shopId:''
      },

      selectCkList:[],
      shopCk:{
        shopId:'',
        cardType:'',
        cardTypeName:'',
        money:'',
        cardNum:'',
        useType:'',
        useTypeName:'',
        state:'',
        validDate:'',
        createTime:'',
        createName:'',
        consumptionId:'',
        consumptionName:'',
        price:'',
        shopIds:[],
        ckInfos:[],
        creator:'',
      },
      stateText:[
        {state:1,name:'正常'},
        {state:2,name:'过期'},
      ],
    }
  },
  methods:{
    checkSelect(row,index){
      if(row.state == 2){
        return false;
      }
      if(row.state == 1){
        return true;
      }
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.orgName.indexOf(value) !== -1;
    },
    async loadOrg(){
      const {data:res} = await this.$http.get(`orgList/orgId/${this.shopId}`);
      this.orgList = [res.data];
    },
    showCkDialog(){
      this.clear();
      this.ckDialogVisible = true;
    },
    closeCkDialog(){
      this.ckDialogVisible = false;
    },
    typeFormatter(row) {
      let value = "";
      for (let i = 0; i < this.stateText.length; i++) {
        let item = this.stateText[i];
        if (row.state === item.state) {
          value = item.name;
          break;
        }
      }
      return value;
    },
    async sjCk(){
      this.$loading({lock: true,fullscreen: true, text: 'Loading...'});
      this.shopCk.shopIds = this.$refs.tree.getCheckedKeys();
      this.shopCk.ckInfos = this.selectCkList;
      this.shopCk.creator = this.userId;
      const {data:res} = await this.$http.post(`/sj/shopCk`, this.shopCk);
      if (res.code === 200){
        this.$message.success("操作成功！")
        this.$loading({lock: true,fullscreen: true, text: 'Loading...'}).close();
      } else {
        this.$message.error("操作失败！")
      }
    },
    async xjCk(){
      this.$loading({lock: true,fullscreen: true, text: 'Loading...'});
      this.shopCk.shopIds = this.$refs.tree.getCheckedKeys();
      this.shopCk.ckInfos = this.selectCkList;
      this.shopCk.creator = this.userId;
      const {data:res} = await this.$http.post(`/xj/shopCk`, this.shopCk);
      if (res.code === 200){
        this.$message.success("操作成功！")
        this.$loading({lock: true,fullscreen: true, text: 'Loading...'}).close();
      } else {
        this.$message.error("操作失败！")
      }
    },
    fpCk(){

    },
    async createCk(){
      this.$loading({lock: true,fullscreen: true, text: 'Loading...'});
      if(this.useType == ''){
        this.$message.warning("请选择用途");
        this.$loading({lock: true,fullscreen: true, text: 'Loading...'}).close();
        return;
      }
      if(this.ckInfo.validDate == ''){
        this.$message.warning("请选择有效期");
        this.$loading({lock: true,fullscreen: true, text: 'Loading...'}).close();
        return;
      }
      this.ckInfo.useType = this.useType;
      this.ckInfo.creator = this.userId;
      const {data:res} = await this.$http.post(`/new/ck`, this.ckInfo);
      if (res.code === 200){
        this.$message.success("操作成功！")
        this.$loading({lock: true,fullscreen: true, text: 'Loading...'}).close();
      } else {
        this.$message.error("操作失败！")
      }
      this.loadCk();
      this.closeCkDialog();
    },
    showConsumptionDialog(){
      this.loadCkConsumption();
      this.ckConsumptionDialogVisible = true;
    },
    closeConsumptionDialog(){
      this.ckConsumptionDialogVisible = false;
    },
    loadCk(){
      this.baseRequest.pageNum = this.currentPage;
      this.baseRequest.pageSize = this.pageSize;
      this.loadCkCount();
      this.loadCkList();
    },
    async loadCkCount(){
      const {data:res} = await this.$http.post(`/ck/count`, this.baseRequest);
      this.pageTotal = res.totalPage;
    },
    async loadCkList(){
      const {data:res} = await this.$http.post(`/ck/list`, this.baseRequest);
      this.ckList = res.data;
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.loadOrders();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.loadOrders();
    },
    handleSizeChange1(val) {
      this.pageSize1 = val;
      this.loadCkConsumptionList();
    },
    handleCurrentChange1(val) {
      this.currentPage1 = val;
      this.loadCkConsumptionList();
    },
    loadCkConsumption(){
      this.baseRequest.pageNum = this.currentPage1;
      this.baseRequest.pageSize = this.pageSize1;
      this.baseRequest.shopId = this.shopId;
      this.loadCkConsumptionCount();
      this.loadCkConsumptionList();
    },
    async loadCkConsumptionCount(){
      const {data:res} = await this.$http.post(`/load/ck/consumption/count`, this.baseRequest);
      this.pageTotal1 = res.totalPage;
    },
    async loadCkConsumptionList(){
      const {data:res} = await this.$http.post(`/load/ck/consumption/list`, this.baseRequest);
      this.ckConsumptionList = res.data;
    },
    selectCkConsumption(data){
      this.ckInfo.cardTypeName = data.serviceName;
      this.ckInfo.cardNum = data.cardNum;
      this.ckInfo.consumptionId = data.id;
      this.ckInfo.price = data.price;
      this.closeConsumptionDialog();
    },
    handleSelectionChange(val){
      this.selectCkList = val;
    },
    clear(){
      this.ckInfo.useType = '';
      this.ckInfo.price = '';
      this.ckInfo.cardTypeName ='';
      this.ckInfo.price ='';
      this.ckInfo.cardNum='';
      this.ckInfo.consumptionId = '';
      this.ckInfo.useType = '';
      this.ckInfo.useTypeName = '';
      this.ckInfo.validDate = '';
      this.ckInfo.footService = '';
      this.ckInfo.ckIndex = '';
    }
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    }
  },
  created() {
    this.shopId = window.sessionStorage.getItem('currentOrgId');
    this.userId = window.sessionStorage.getItem("userId");
    this.authorities = window.sessionStorage.getItem('authorities');
    this.loadOrg();
    this.loadCk();
  }
}
</script>

<style lang="less" scoped>
.container{
  height: 100vh;
  overflow-y: hidden;
}
.between{
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  height: 100vh;
}
.left_con::-webkit-scrollbar {
  width: 0 !important
}
.left_con{
  display: flex;
  justify-content: start;
  height: 100%;
  overflow-y: auto;
  flex: 1;
  margin: 10px 0;
  width: 30%;
}
.left_inner_con{
  width: 100%;
  height: 90vh;
  overflow-y: auto;
  margin-right: 10px;
}
.left_inner_con::-webkit-scrollbar {
  width: 0 !important
}
.table_container{
  flex: 1;
  width: 70%;
}
.el-table, .el-table__cell {
  /deep/ th {
    padding: 2px ;
  }
  /deep/ td {
    padding: 2px ;
  }
}
/deep/ .el-dialog__header{
  z-index: 1;
  position: relative;
  color: #333 !important;
  .el-dialog__title{
    color: #333;
  }
  .el-dialog__close{
    color: #333 !important;
  }
}
/deep/.el-dialog__body{
  padding-top: 10px;
}
.dialog-height{
  height: 600px !important;
}
.dialog-footer{
  display: flex;
  margin: 10px 0;
  justify-content: center;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/CiCard.vue